import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 8px;
`

export const Title = styled.div`
  margin-bottom: 12px;
  color: black;
  font-weight: bold;
`
